<div class="main-popup mt-3">
    <div class="main-title-popup mb-4 text-center">
        <h1>Body Weight</h1>
    </div>
    <form [formGroup]="bodyWeightForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <!-- Date Field - Full Width Row -->
            <div class="col-md-12 mb-3">
                <label for="date"
                    >Date<span class="text-danger-required">*</span></label
                >
                <input
                    formControlName="date"
                    type="date"
                    class="form-control"
                    id="date"
                    placeholder="Please choose date"
                    [ngClass]="{
                        'is-invalid':
                            bodyWeightForm.get('date').invalid &&
                            bodyWeightForm.get('date').touched,
                        'is-valid':
                            !bodyWeightForm.get('date').invalid &&
                            bodyWeightForm.get('date').touched
                    }"
                />
                <div
                    *ngIf="
                        bodyWeightForm.get('date').invalid &&
                        bodyWeightForm.get('date').touched
                    "
                    class="text-danger"
                >
                    Please select a date.
                </div>
            </div>

             <!-- Farm House Field -->

                <div class="col-md-12 mb-3">
                    <label for="farmHouseId">
                        Farm House<span class="text-danger-required">*</span>
                    </label>

                    <select
                        formControlName="farmHouseId"
                        id="farmHouseId"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid':
                                bodyWeightForm.get('farmHouseId').invalid &&
                                bodyWeightForm.get('farmHouseId').touched,
                            'is-valid':
                                !bodyWeightForm.get('farmHouseId').invalid &&
                                bodyWeightForm.get('farmHouseId').touched
                        }"
                    >
                        <option [ngValue]="null">
                            Please select farm house
                        </option>

                        <option
                            *ngFor="let house of houses"
                            [ngValue]="house.houseId"
                        >
                            {{ house.houseName }}
                        </option>
                    </select>

                    <div
                        *ngIf="
                            bodyWeightForm.get('farmHouseId').invalid &&
                            bodyWeightForm.get('farmHouseId').touched
                        "
                        class="text-danger"
                    >
                        Please select a farm house.
                    </div>
                </div>
        </div>

        <!-- Weight Entries -->
        <div formArrayName="weights">
            <div
                class="add-ave-medication"
                *ngFor="let weight of weights.controls; let i = index"
                [formGroupName]="i"
            >
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <label for="weight-{{ i }}"
                            >Weight (gram)<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <input
                            type="number"
                            formControlName="weight"
                            id="weight-{{ i }}"
                            class="form-control"
                            placeholder="Please enter weight"
                            [ngClass]="{
                                'is-invalid':
                                    weight.get('weight').invalid &&
                                    weight.get('weight').touched,
                                'is-valid':
                                    !weight.get('weight').invalid &&
                                    weight.get('weight').touched
                            }"
                        />
                        <div
                            *ngIf="
                                weight.get('weight').invalid &&
                                weight.get('weight').touched
                            "
                            class="text-danger"
                        >
                            Please enter a valid weight.
                        </div>
                        <span
                            class="text-danger"
                            *ngIf="weight.get('weight').errors?.min"
                        >
                            Value must be non-negative.
                        </span>
                    </div>
                </div>

                <!-- Remove Button -->
                <div class="row">
                    <div class="col-md-12 text-right">
                        <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            (click)="removeWeightField(i)"
                            [disabled]="weights.length <= 1"
                            title="Remove this weight entry"
                        >
                            <i class="fas fa-trash-alt"></i>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Weight Button -->
        <div class="row">
            <div class="col-md-12 text-right mt-1">
                <button
                    type="button"
                    class="btn-action"
                    (click)="addWeightField()"
                >
                    <span class="vaccine-plus">
                        <i class="fas fa-plus"></i>
                    </span>
                    Add Weight Entry
                </button>
            </div>
        </div>

        <!-- Submit Button -->
        <div class="add-mortality-save text-center">
            <button
                class="btn btn-action-primary"
                type="submit"
                [disabled]="isLoading$ | async"
            >
                <span *ngIf="!isAuthLoading">Submit</span>
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
            <img
                *ngIf="isLoading$ | async"
                src="assets/img/loader.gif"
                alt="Loading..."
                class="loader-image mt-2"
            />
        </div>
    </form>
</div>
